<template lang="html">
  <StandardDialog @click-outside="$router.push({ name: 'AccountClients'})">
    <template #content>
      <StandardTextCard
        height="74vh"
        name="Add Projects"
        :clickable="false"
      >
        <template #info>
          <v-row>
            <StandardCard
              v-for="project in getOwnProjectOverview"
              :key="project.id"
              :image="project.image"
              :name="project.name"
              :cols="3"
              clickable="true"
              @click.native="selectOrDeselect(project.id)"
              >
              <template #badge>
                <StandardBadge
                :show_icon_cond="isInSelection(project.id)"
                show_icon="done"
                color="white"
                content_color="black"
                />
              </template>
            </StandardCard>
          </v-row>
        </template>
        <template #actions>
          <v-btn color="blue" text @click="requestAddProjects()">{{$t('Account.AccountClients.AddProjects')}}</v-btn>
          <v-btn color="red" text @click="$router.push({ name: 'AccountClients'})">{{$t('Buttons.Cancel')}}</v-btn>
        </template>
      </StandardTextCard>
    </template>
  </StandardDialog>
</template>

<script>
import StandardTextCard from '@/components/StandardComponents/StandardTextCard.component.vue';
import StandardDialog from '@/components/StandardComponents/StandardDialog.component.vue';
import StandardCard from '@/components/StandardComponents/StandardCard.component.vue';
import StandardBadge from '@/components/StandardComponents/StandardBadge.component.vue';
import store from '@/store/index';
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'AccountClientsAddProjects',
  components: {
    StandardTextCard, StandardDialog, StandardCard, StandardBadge
  },
  beforeRouteEnter(to, from, next){
    store.dispatch('Project/requestOwnerProjects', to.params.client_id).then( () => { next(); });
  },
  props: ['client_id'],
  data: function () {
    return {
      selection: []
    }
  },
  created(){

  },
  computed: {
    ...mapGetters('Project', [
      'getOwnProjectOverview',
      'getOwnProject'
    ])
  },
  methods: {
    ...mapActions('Client', [
      'addClientToProjects'
    ]),
    selectOrDeselect(id){
      let index = this.selection.indexOf(id);
      if (index === -1) {
        this.selection.push(id);
      } else {
        this.selection.splice(index, 1);
      }
    },
    isInSelection(id){
      if (this.selection.indexOf(id) !== -1) {
        return true;
      } else {
        return false;
      }
    },
    requestAddProjects(){
      let projects = [];
      for (let i = 0; i < this.selection.length; i++) {
        projects.push({ id: this.selection[i]});
      }
      this.addClientToProjects({
        client_id: this.client_id,
        payload: {projects: projects}
      });
      let self = this;
      setTimeout(function () {
        self.$router.push({name: 'AccountClients'});
      }, 750);
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
